import { MenuItem } from '@domain/types';
import { createReducer, on } from '@ngrx/store';
import { menuItems } from '@shared/components/template-menu/constants/menu-items';
import { loadMenuItems, updateMenuItems } from '@store/actions/menu-items.actions';

export const initialState: MenuItem[] = menuItems;

export const menuItemsReducer = createReducer(
    initialState,
    on(loadMenuItems, (state) => {
        return {
            ...state,
        };
    }),
    on(updateMenuItems, (state, action) => {
        const items = [
            ...state.map((item) => {
                return {
                    ...item,
                    active: false,
                };
            }),
        ];
        const mItems = items.map((item) => {
            if (item.name.toLowerCase() === action.menuItem.name.toLowerCase()) {
                return {
                    ...item,
                    active: action.firsLevelNavigation,
                };
            }
            return { ...item };
        });
        return [...mItems];
    })
);
